<div class="adtabcontent">
  <app-column-header [headerData]="headerData" (topbtnaction)="onSubmit()"></app-column-header>
  <div class="admintabfields">
    <form [formGroup]="createPageForm" (ngSubmit)="onSubmit()">
      <!-- <div class="row"> -->
      <div class="filedgrid thrcol">
        <div class="colbox">
          <label class="">Page Name</label>
          <input type="text" formControlName="pageName" class="formgroup" maxlength="30"
            [ngClass]="{'is-invalid': submitted && f.pageName.errors}" placeholder="Enter Page Name">
        </div>
        <div class="colbox">
          <label class="control-label">Page Description</label>
          <input type="text" formControlName="pageDesc" class="formgroup" placeholder="Enter Page Description">
        </div>
        <div class="colbox ">
          <label class="control-label">Icon</label>
          <ng-select class="formgroup" [items]="iconListOption" formControlName="pageIcon" placeholder="Icon Option"
            appendTo="body" bindLabel="name" bindValue="id"></ng-select>
        </div>
        <div class="colbox">
          <svg class="adicon">
            <use [attr.xlink:href]="srcPath.menuIconPath+createPageForm.value.pageIcon"></use>
          </svg>
        </div>
        <div class="colbox" *ngIf="createPageForm.value.createWithMenu == 1 && menuListdata.length>0 && (false)">
          <!-- <label class="control-label">Parent Menu</label> -->
          <ng-select class="formgroup" palceholder="-Select-" formControlName="parentMenuId" [items]="menuListdata"
            bindLabel="gstibo_menu_name" bindValue="gstibo_menu_id" appendTo="body"></ng-select>
        </div>
      </div>
      <hr>
      <div class="filedgrid thrcol">
      <div class="chkbox " *ngIf="createPageForm.value.pageId == 0 && inputMode == '1'" style="margin-bottom: 15px;">
        <input name="createWithMenu" class="checkBox" type="checkbox" id="createWithMenu"
          formControlName="createWithMenu" />
        <label class="control-label" for="createWithMenu"><span></span>Is Inner Page
        </label>
      </div>
      <div class="colbox" *ngIf="moduleListdata.length>0" >
        <label class="control-label">Module Name</label>
      <ng-select class="form-control" palceholder="-Select-" (change)="onModuleChange()" *ngIf="moduleListdata.length>0" formControlName="moduleId" [items]="moduleListdata"
        bindLabel="gstibo_menu_name" bindValue="gstibo_menu_id" appendTo="body"
        ></ng-select>
    </div>
    <div class="colbox" *ngIf="childMenuListdata.length>0">
        <label class="control-label">Menu Name</label>
      <ng-select class="form-control" palceholder="-Select-" formControlName="withMenuGroupId" [items]="childMenuListdata"
        bindLabel="gstibo_menu_name" bindValue="gstibo_menu_id" appendTo="body"
        ></ng-select>
    </div>
      </div>
      <hr>
      <div class="filedgrid thrcol">
        <div class="colbox">
          <label class="control-label">Background color</label>
          <input type="color" class="form-control inputText inputColor" placeholder="Enter Background color"
            formControlName="pageBgColor">
        </div>
        <div class="colbox">
          <label class="control-label">Icon style</label>
          <ng-select class="form-control" [items]="iconStyleOption" formControlName="pageIconStyle"
            placeholder="Icon Style" bindLabel="name" bindValue="id"></ng-select>
        </div>
        <div class="colbox">
          <!-- <div class="formGroup "> -->
          <label class="control-label">Popup Width Class</label>
          <ng-select class="form-control" [items]="popupWidthClassOption" formControlName="popupWidthClass"
            placeholder="Class" bindLabel="name" bindValue="id"></ng-select>
          <!-- </div> -->
        </div>
      </div>
      <hr>
      <div class="filedgrid thrcol">
        
        <div class="colbox">
          <div class="chkbox">
            <input name="linkPage" class="checkBox" type="checkbox" id="linkPage" formControlName="isPagelinked" />
            <label class="control-label" for="linkPage"><span></span>Link Page
            </label>
          </div>
        </div>
        <div class="colBox">
          <div class="chkbox ">
            <input name="showstatic" class="checkBox" type="checkbox" id="staticdata"
              formControlName="isStaticPagelinked" />
            <label class="control-label" for="staticdata"><span></span>Need to Show Static Data
            </label>
          </div>

        </div>

        <div class="chkbox ">
          <input name="sametable" class="checkBox" type="checkbox" id="sametable" formControlName="isSameTable" />
          <label class="control-label" for="sametable"><span></span>Same Table
          </label>
        </div>
      </div>
      <div class="filedgrid thrcol">
        <div class="colbox">
          <div class="formGroup"  *ngIf="createPageForm.value.isPagelinked == 1 && appPageList.length>0">
            <ng-select class="form-control" formControlName="linkPageId" [items]="appPageList" placeholder="Select page"
              bindLabel="pageName" bindValue="pageId"></ng-select>
          </div>
        </div>
        <div class="colbox" >
          <div class="formGroup" *ngIf="createPageForm.value.isStaticPagelinked== 1 && appPageList.length>0">
            <ng-select class="form-control" formControlName="staticPageId" [items]="appPageList"
              placeholder="Select page" bindLabel="pageName" bindValue="pageId"></ng-select>
          </div>
        </div>
        <div class="colbox">
          <div class="formGroup"  *ngIf="createPageForm.value.isSameTable== 0 && tableList.length>0">
            <ng-select class="form-control" formControlName="pageTableName" [items]="tableList"
              placeholder="Select Table" bindLabel="tableName" bindValue="tableName"></ng-select>
          </div>
        </div>
      </div>
      <div class="filedgrid thrcol">
       <div class="colbox">
        <label class="control-label" *ngIf="createPageForm.value.pageId">Table Name</label>
        <div class="formGroup" *ngIf="createPageForm.value.pageId">
          <input  readonly class="form-control" formControlName="pageTableName" bindLabel="tableName"
            bindValue="tableName">
        </div>
      </div>
      </div>

    </form>
  </div>
</div>